<template>
<svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 70.402 70.402">
  <g id="Group_72" data-name="Group 72" transform="translate(-34.26 -279.299)">
    <circle id="Ellipse_33" data-name="Ellipse 33" cx="35.201" cy="35.201" r="35.201" transform="translate(34.26 279.299)" fill="#fff"/>
    <path id="Path_157" data-name="Path 157" d="M87,304.756A19.232,19.232,0,0,0,78.761,293.5l.973-1.67-1.683-.981-3.6,6.173A14.134,14.134,0,0,0,60.267,321.36l-3.861,6.626,1.683.981,1.185-2.034a19.269,19.269,0,0,0,8.024,2.206v2.1l-5.8.968v4.7H75.059v-4.7l-5.814-.969v-2.1a19.47,19.47,0,0,0,4.044-.635A19.385,19.385,0,0,0,87,304.756Zm-25.109.177h12.97v3.328H61.889Zm0,6.335h12.97V314.6H61.889Zm21.486,7.225a17.4,17.4,0,0,1-23.114,6.746l1.681-2.883a14.126,14.126,0,0,0,14.205-24.375l1.633-2.8a17.4,17.4,0,0,1,5.6,23.314Z" fill="#1a1818"/>
  </g>
</svg>
</template>

<script>
export default {
  'name': 'SA_02_03',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/attributes/SA_02_03.vue